import React from 'react';
import Hero from './Hero';
import FAQ from './FAQ';
import Footer from './Footer';
import { useGetUserSessionQuery } from '../../../services/api/userApi';

const Landing = () => {
    const { data: userSessionData, isLoading: isUserSessionLoading, isError: isUserSessionError, isFetching: isUserSessionFetching } = useGetUserSessionQuery();
    const isLoggedIn = userSessionData?.isLoggedIn;
    const isSubscribed = userSessionData?.isSubActive?.isActive;

    return (
        <div className="bg-white dark:bg-brand-dark-900 h-full overflow-y-auto">
            <Hero isAuthenticated={isLoggedIn} isSubscribed={isSubscribed} />
            <div id="faq">
                <FAQ />
            </div>
            <Footer />
        </div>
    );
};

export default Landing;
